"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Image = _interopRequireDefault(require("../../atoms/Image/Image"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _ButtonImage = require("./ButtonImage.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ButtonImage = function ButtonImage(_ref) {
  var _ref$src = _ref.src,
      src = _ref$src === void 0 ? '' : _ref$src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '30px' : _ref$size,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? true : _ref$rounded,
      action = _ref.action,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-button-image' : _ref$dataTestId;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_ButtonImage.Occ_ButtonImage, {
    onClick: action,
    "data-test-id": dataTestId
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    src: src,
    alt: alt,
    rounded: rounded,
    width: size,
    height: size,
    cover: true
  })));
};

var _default = ButtonImage;
exports["default"] = _default;